import { useCSSSafeId } from "@/shared/hooks/useCSSSafeId";
import { FieldProvider } from "./FieldContext";
import { FieldFooter } from "./FieldFooter";
import { FieldLabel } from "./FieldLabel";
import { FieldUsage } from "./FieldUsage";
import { FormFieldConnector } from "./FormFieldConnector";
import { GenericExactness } from "./GenericExactness";
import { GenericField } from "./GenericField";
import {
    LimitedValuesField,
    NumberField,
    PlaceAutocompleteField,
    StringField,
    ValueRangeField,
    YearField,
} from "./basic-fields";
import { YearExactness } from "./field-exactness";
import { NameExactness } from "./field-exactness/NameExactness";
import { PlaceExactness } from "./field-exactness/PlaceExactness";
import type { FieldComposerProps } from "./types";

function FieldComposer({ fieldPath, exactnessFieldPath, fieldConfig, children }: FieldComposerProps) {
    const fieldHtmlId = useCSSSafeId();

    return (
        <FieldProvider
            value={{
                fieldPath,
                exactnessFieldPath,
                fieldConfig,
                fieldHtmlId,
            }}
        >
            {children}
        </FieldProvider>
    );
}

FieldComposer.Label = FieldLabel;
FieldComposer.GenericField = GenericField;
FieldComposer.GenericExactness = GenericExactness;
FieldComposer.UsageText = FieldUsage;
FieldComposer.Footer = FieldFooter;

FieldComposer.PlaceExactness = PlaceExactness;
FieldComposer.YearExactness = YearExactness;
FieldComposer.NameExactness = NameExactness;

FieldComposer.FieldConnector = FormFieldConnector;
FieldComposer.Inputs = {
    Number: NumberField,
    String: StringField,
    LimitedValues: LimitedValuesField,
    ValueRange: ValueRangeField,
    Year: YearField,
    Place: PlaceAutocompleteField,
};

export { FieldComposer };
